export default "__VITE_ASSET__CANI3jiu__"